var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.isActive},[(_vm.item && !_vm.item.hide_in_list)?_c('ion-item',{staticClass:"ion-text-wrap",attrs:{"detail":_vm.isArticle,"button":""},on:{"click":function($event){return _vm.$router.push(_vm.itemURL)}}},[_c('span',[_vm._v(_vm._s(_vm.item.name))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }